import type { AxiosError } from 'axios';
import ms from 'ms';
import { useQuery } from 'react-query';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import * as errorReporting from 'hb-react/shared/utils/errorReporting';

interface Tag {
  label: string;
  name: string;
}

interface GetTagsProps {
  fetchTags: () => Promise<Tag[]>;
  queryId: string;
}

export const useGetTags = ({ fetchTags, queryId }: GetTagsProps) => {
  const { topicId } = useTopicContext();

  const { data } = useQuery<Tag[], AxiosError>([queryId, topicId], fetchTags, {
    staleTime: ms('5m'),
    onError: (error) => {
      errorReporting.captureException(error);
    },
  });

  return data || [];
};
